<template>
  <div style="padding-top: 1rem;">
    <!-- <div class="top_title fixed">用户协议</div> -->
    <p>
      欢迎阅读服务条款协议，本协议阐述之条款和条件适用于您使用中国网络游戏服务网
      及相关移动产品（以下简称&ldquo;G买卖&rdquo;）的各种功能和享受的各项G买卖服务（以下简称&ldquo;服务&rdquo;）。本服务协议具有合同效力。<br />
      &nbsp;&nbsp;&nbsp;
      本服务协议内容包括本协议正文及所有本G买卖已经发布的或将来可能发布的各类规则、声明等各项规范G买卖运营及明确本公司和用户权利义务、责任的文件资料。所有规则、声明等均为本服务协议不可分割的一部分，与本服务协议具有同等法律效力。在本G买卖中没有以&ldquo;规则&rdquo;、&ldquo;声明&rdquo;字样表示的链接文字所指示的文件就专门的事项与本服务协议有不同规定的，在不违反本服务协议基本原则的前提下优先适用其规定，且仅适用于该专门的事项。<br />
      &nbsp;&nbsp;&nbsp;
      <b>用户在使用本G买卖提供的各项服务的同时，承诺接受并遵守本服务协议及各项相关规则、声明的规定。本G买卖有权根据需要不时制定、修改本协议或各类规则、声明，如本协议有任何变更，将在G买卖上以刊载公告的方式通知予用户。如用户不同意相关变更，必须停止使用本G买卖各
      项功能和享受各项&ldquo;服务&rdquo;。经修订的协议一经在本G买卖上公布，立即自动生效。各类规则、声明等会在发布后生效，亦成为本协议的一部分。登录或继续使用本网
      站各项功能或享受各项&ldquo;服务&rdquo;将表示用户接受经修订的协议。除另行明确声明外，任何使&ldquo;服务&rdquo;范围扩大或功能增强的新内容均受本协议约束。</b><br />
      <strong
        ><strong
          >鉴于本G买卖无法掌控和确定用户是否已仔细阅读服务协议内容，且阅读与否责任并不在本G买卖和本公司，因此特别声明如下：</strong
        ></strong
      ><br />
      <strong
        ><strong
          >&nbsp;(1)&nbsp;无论用户事实上是否在登陆之前认真阅读了本服务协议，只要用户点击登陆页面的&ldquo;我同意&rdquo;选项，并按照G买卖登陆程序成功注册为G买卖用户，即视为用户已经全文阅读并接受本服务协议之全部内容，本服务协议即在本公司和用户之间签订，对双方具有约束力。</strong
        ></strong
      ><br />
      <strong
        ><strong
          >(2)&nbsp;本协议仅系本公司与本G买卖用户间因使用本G买卖而产生的权利义务关系，不涉及本G买卖用户之间因网上交易而产生的法律关系及法律纠纷。</strong
        ></strong
      >
    </p>

    <h2>《G买卖用户协议》</h2>
    <ol>
      <li style="text-align: center;">总则</li>
    </ol>
    <b>第一条 协议双方定义</b><br/>
    <p>
      甲方：个人客户，使用&ldquo;G买卖&rdquo;提供虚拟物品交易服务的个人客户，包括卖方和买方。<br />
      乙方：G买卖服务提供商。<br />
      为明确双方的权利和义务，规范双方行为，本着平等互利的原则，就虚拟物品服务平台服务的相关事宜达成《G买卖用户协议》(以下简称本协议)
      。
    </p>
    <br/>
    <b>第二条 甲方权利、义务</b><br/>
    <p>
      1.权利<br />
      1.1.甲方自愿申请使用乙方虚拟物品交易服务。<br />
      1.2.甲方对乙方虚拟物品交易服务如有疑问、建议或意见时，可联系G买卖在线客服进行咨询和投诉。<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.义务<br />
      2.1.甲方发布出售物品或购买物品前须确认该物品真实存在。作为卖方时，保证出售物品具有合法来源，合法拥有出售的物品或合法享有对出售物品的处分权，且出售物品的行为不违反物品所属的网络游戏的开发商或运营商制定的对该网络游戏的管理规则的相关规定（因违反上述游戏管理规则所导致的交易风险由甲方自行承担）。<br />
      2.2.甲方作为卖方出售物品经发布上架后，至该物品成交或下架前，须始终保证其真实存在且物品的属性不得发生任何可能降低其交易价值的变化。<br />
      2.3.物品成交后，在买家支付款项并获得出售的物品后，未经买家同意，卖家不得以任何方式取回已出售的物品。擅自取回的，应当向买家承担赔偿责任，情节严重的，应承担相应的刑事责任。<br />
      <b>2.4.甲方同意在出售物品成交后, 如卖家不交货或交货不及时, 由G买卖商城扣除其一定数额的保证金并支付给买家作为补偿的, 卖家无条件同意G买卖商城或其委托方对于卖家不交货或交货不及时的判定。</b><br />
      2.5.甲方承诺自己在使用乙方提供的服务时实施的所有行为遵守国家法律、法规和甲方公司的相关规定以及各种社会公共利益或公共道德。甲方从事非法活动或不正当交易产生的一切后果与责任，由甲方独立承担。<br />
      2.6.甲方在销售商品的过程中，必须准确填写或认证联系方式，如：手机、邮箱等。以便客服能及时联系卖家处理相关投诉和事件。如因客服联系不上卖家而造成的订单退款和赔付由该卖家自行承担G买卖商城不负任何责任。<br />
      <b>2.7.甲方在G买卖商城进行销售活动时，有义务配合G买卖商城进行客户服务，对于不履行该义务的卖家，商城有权取消其在商城的销售资格。当对本协议提到的相关事实的确认存在争议时，甲方同意以G买卖商城对事实的判定为最终的依据。</b><br />
      2.8 .甲方所进行的物品交易必须是游戏内发行的可交易物品，不得进行与游戏无关的任何交易行为，否则将被乙方定性为虚假交易行为，乙方有权直接封禁甲方账户，若涉及行政或刑事案件的，乙方有权直接移交相关部门处理。<br/>
      <br/>
      <b>第三条 乙方权利、义务</b><br />
      1.权利<br />
      1.1.乙方有权根据甲方资信情况或交易记录，决定是否受理甲方的虚拟物品交易业务。乙方有权根据需要或相关法律法规的规定搜集甲方的身份信息及银行账户信息，并根据注册信息等对甲方从事交易的权限和身份进行核实。<br />
      <b>1.2.乙方有权根据自身业务的发展增加、减少或撤消服务虚拟物品交易种类，调整虚拟物品交易服务的内容；乙方有对G买卖功能进行升级、改造的权利。</b><br />
      1.3.乙方可以基于向甲方更好的提供本服务或提供其他产品服务的目的，保留并使用甲方填写的资料以及甲方的服务使用记录。<br />
      1.4.乙方有权对甲方的注册资料及交易行为进行查阅，发现注册资料或交易行为中存在问题，或可能会导致不良后果的，有权向甲方发出询问，要求甲方进一步提供必要的信息或直接对相关的交易作出相应的处理。<br />
      1.5.甲方的注册资料或其他信息不符合乙方要求的，乙方有权拒绝提供服务或取消甲方的交易资格，而无须预先通知甲方。甲方利用G买卖从事非法交易或不正当活动的，乙方有权停止其业务。<br />
      <b>1.6.乙方有权在发生下述任一情况下，中断或终止本服务而不承担任何赔偿责任：</b><br />
      <b>1.6.1乙方基于单方判断，认为甲方已经违反本服务条款的规定。</b><br />
      <b>1.6.2乙方在发现甲方注册资料存在虚假、异常交易或有疑义或有违法嫌疑时。</b><br />
      <b>1.7.协议终止或服务有效期内中止时，乙方不退回甲方已支付的有关费用。</b><br />
      <b>1.8.因甲方的账号和密码，支付宝账号和密码，游戏账号和密码，安全交易验证码等相关账号或安全信息被泄露或被盗用所造成的一切损失由卖家自行承担。</b>但因G买卖商城或其委托方直接造成上述卖家信息泄露而导致卖家损失的除外。
      如您发现有他人冒用或盗用您的账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知本公司，要求本公司暂停相关服务。同时，您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及(或)所导致的您的损失不承担任何责任。<br />
      <b>1.9.如果甲方连续在大量的商品中重复留言，提供联系方式进行议价、收购，乙方有权利禁止甲方登录，视情节严重程度封停不同时间。</b><br />
      2.义务<br />
      2.1.乙方有义务在技术上确保整个网上服务平台的安全、有效、正常运行，保证甲方正常交易活动的顺利进行，
      并及时向甲方提供查询交易记录、交易资金状态、账户状态等服务。<b>但不承担因通讯、停电故障、黑客攻击、支付银行问题、不可抗力等非乙方原因所引起交易中
      断、交易错误引起的责任。</b><br />
      2.2.乙方对甲方在注册中提供的相关身份资料及在交易中产生的交易记录负有保密义务，但有权利根据法律法规规定向有权查询的法定机构，或为完成交易指令的需要向第三方提供。<br />
      <b>2.3.乙方可对用户收取合理的交易费用，并可能根据业务发展对费用进行变更。乙方应向甲方明示交易费用及其变更，如甲方不接受相关费用标准及其变更，则不应进行交易。甲方进行交易视为接受相关费用标准及其变更。
      甲方如果需要乙方为收取的手续费开具发票，需联系客服提供发票的收寄地址，并承担对应的邮寄费用。</b><br />
      2.4.乙方负责向甲方提供业务咨询服务，并在乙方G买卖公布功能介绍、新手帮助、交易规则等内容。<br />
      <br/>
      <b>第四条 禁止行为。</b><br>
      <b>甲方不得进行任何侵犯乙方或第三方知识产权的行为，或者进行其他有损于乙方或其他用户合法权益的行为，包括但不限于：</b><br />
      <b>
      1.
      甲方对乙方平台及其中的相关信息擅自复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，借助乙方平台发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；<br />
      2.
      甲方在乙方平台中内置各种插件程序或者其他的第三方程序，或者制作、发布、传播上述程序，而无论是否出于商业目的；<br />
      3. 甲方进行编译、反编译、反向工程或者以其他方式破解乙方平台的行为；<br />
      4. 甲方使用乙方平台外挂和/或利用乙方平台当中的BUG来获得不正当的利益；<br />
      5.
      甲方利用劫持域名服务器等技术非法侵入、破坏乙方平台的服务器软件系统，或者修改、增加、删除、窃取、截留、替换乙方平台的客户端和/或服务器软件系统中的数据，或者非法挤占乙方平台的服务器空间，或者实施其他的使之超负荷运行的行为；<br />
      6. 甲方假冒乙方或商家在乙方平台当中发布任何诈骗或虚假信息；<br />
      7. 甲方利用乙方平台故意传播恶意程序或计算机病毒。<br />
      8. 甲方在乙方平台当中发布任何诈骗、虚假信息或来路不明商品。<br /></b>
      <br/>
      <b>第五条 协议修改</b><br />
      1.乙方将有权随时修改本协议的有关条款，一旦本协议的内容发生变动，G买卖将会通过电子邮件或G买卖公告等方式向甲方提示修改内容。<br />
      <b>2.如果甲方不同意乙方对本协议相关条款所做的修改，甲方有权停止使用乙方提供的服务。如果甲方继续使用乙方提供的服务，则视为其同意本协议相关条款的修改。</b><br />
      <br/>
      <b>第六条 免责</b><br />
      <b>
        1.甲方自身未按规定操作，或由于自身其他原因造成交易失败等其他损失时，乙方不承担责任，甲方应及时联系G买卖在线客服。乙方应积极调查并告知甲方调查结果。<br />
      2.乙方拥有对该协议条款的最终解释权，如果您对本声明的条款有疑问的，请通过客服渠道进行询问。<br />
      3.关于以下事由造成的各项损失，本公司免责：<br />
      3.1.战争、事变、天灾地变等，不可抗力等情况；<br />
      3.2.使用者故意或过失所造成损害；<br />
      3.3.因通信服务提供业者方面造成之通信障碍；<br />
      3.4.用户身份之真实性、民事权利能力民事行为能力之适当性、用户信用程度之可靠性；<br />
      3.5.其他非本G买卖所能控制或掌握之事项。<br />
      4.一切因产品运营活动产生的商品价格浮动，乙方无需承担价格补差。<br />
      5.乙方可通过任何形式对商品进行宣传，不偏离商品实际情况。<br />
      </b>
      <br/>
      <b>第七条 争议的解决</b><br/>
      双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均应提交有管辖权的法院诉讼。<br />
      <br/>
      <b>第八条 违约责任</b><br/>
      本协议任何一方违反本协议规定的内容，给另一方造成损害的，应当承担违约责任，赔偿另一方因此而造成的损失，包括财产损失、名誉损失等。<br />
      <br/>
      <b>第九条 协议的解释</b><br/>
      本协议的成立、生效、履行和解释，均适用中华人民共和国法律；法律无明文规定的，应适用G买卖制定的业务规定和通行的商业惯例。
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
p {
  font-size: 1.3rem;
  text-indent: 2em;
  margin-top: 0.5em;
  line-height: 1.5;
}

h2 {
  text-align: center;
  margin: 0.5rem 0;
}
</style>
